// System-generated maintenance types (hardcoded)
// These match the types generated by MaintenanceCalculationService in the backend
export const SYSTEM_MAINTENANCE_TYPES = [
  { 
    id: 'system_revision', 
    name: 'Révision', 
    duration_days: 1,
    description: 'Révision périodique du véhicule'
  },
  { 
    id: 'system_mileage', 
    name: 'Entretien kilométrique', 
    duration_days: 1,
    description: 'Entretien basé sur le kilométrage'
  },
  { 
    id: 'system_insurance', 
    name: 'Renouvellement assurance', 
    duration_days: 0,
    description: 'Renouvellement de l\'assurance du véhicule'
  },
  { 
    id: 'system_registration', 
    name: '1ère immatriculation', 
    duration_days: 0,
    description: 'Date de première immatriculation / carte grise'
  },
];

